<template>
  <div>
    <v-dialog v-model="showDialog" :max-width="500" persistent no-click-animation>
      <v-card>
        <v-card-title class="d-flex mt-2">
          <div class="ps-2">My Account</div>

          <v-spacer></v-spacer>

          <v-icon @click="close">mdi-window-close</v-icon>
        </v-card-title>

        <v-divider class="mx-3 mb-3"></v-divider>
        <v-form ref="accountFormRef" id="my-account-box">
          <v-card-text class="pb-0">
            <v-container>
              <v-row>
                <v-col class="py-0">
                  <!-- <p class="text-red mb-4">
                    *Please request an update from JOVANI before changing your email.<br />
                    If you change your email before JOVANI updates your email in ERP, you will not be able to log in to
                    this website.
                  </p> -->

                  <dirty-text-field
                    label="Email"
                    v-model="userProfile.email"
                    variant="outlined"
                    density="comfortable"
                    @inputUpdated="inputUpdated()"
                  ></dirty-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <dirty-text-field
                    label="Additional Email"
                    v-model="userProfile.email2"
                    variant="outlined"
                    density="comfortable"
                    @inputUpdated="inputUpdated()"
                  ></dirty-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <v-checkbox v-model="isChangePw" label="Change password"></v-checkbox>
                  <v-expand-transition @after-leave="clearPassword()">
                    <div v-if="isChangePw">
                      <dirty-text-field
                        label="New Password"
                        v-model="userProfile.newPassword"
                        variant="outlined"
                        density="comfortable"
                        type="password"
                        :rules="[rules.required]"
                        @inputUpdated="inputUpdated()"
                      ></dirty-text-field>
                      <dirty-text-field
                        label="Confirm new Password"
                        v-model="userProfile.confirmPassword"
                        variant="outlined"
                        density="comfortable"
                        type="password"
                        :rules="[passwordMatch]"
                        @inputUpdated="inputUpdated()"
                      ></dirty-text-field>
                    </div>
                  </v-expand-transition>
                </v-col>
              </v-row>
              <v-row>
                <v-col> </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-expand-transition>
            <v-card-actions v-if="isDirty" class="mx-5 pb-5">
              <dirty-text-field
                v-if="isDirty"
                class="mt-1"
                label="Current Password"
                v-model="userProfile.currentPassword"
                variant="underlined"
                density="comfortable"
                type="password"
                :rules="[rules.required]"
                @inputUpdated="inputUpdated()"
              ></dirty-text-field>

              <v-spacer></v-spacer>

              <v-btn color="black" variant="flat" class="px-5" @click="save">Save</v-btn>
            </v-card-actions>
          </v-expand-transition>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
// useHead({
//   title: 'My Account'
// })
//const runtimeConfig = useRuntimeConfig()
const appConfigStore = useAppConfigStore()
const appConfig = appConfigStore.appConfig
const { $axios } = useNuxtApp()
const progressbarStore = useProgressbarStore()
const { showSnackbar } = useSnackbarStore()
const { rules } = useValidationRules()
const { setUserData } = useUserStore()
const userStore = useUserStore()

// data
const userProfile = ref({
  currentPassword: null,
  newPassword: null,
  confirmPassword: null
})
const showDialog = ref()
const isDirty = ref(false)
const isChangePw = ref(false)
const accountFormRef = shallowRef()

// watch
// watch(isChangePw, (newVal, oldVal) => {
//   if (oldVal === true && newVal === false) {
//     clearPassword()
//   }
// })

// computed

// method
const inputUpdated = () => {
  const el = document.getElementById(`my-account-box`)
  if (!el) return
  const hasDirtyEl = el.querySelectorAll('.dirty').length > 0
  //console.log('>> inputUpdated', isDirty.value, hasDirtyEl)
  if (isDirty.value != hasDirtyEl) isDirty.value = hasDirtyEl
}
const clearPassword = () => {
  userProfile.value.currentPassword = null
  userProfile.value.newPassword = null
  userProfile.value.confirmPassword = null
  isChangePw.value = false
  // nextTick(() => {
  //   inputUpdated()
  // })
}
const passwordMatch = () =>
  (userProfile.value.newPassword && userProfile.value.confirmPassword === userProfile.value.newPassword) ||
  'Password do not match.'

const init = () => {
  userProfile.value.email = userStore.userData.email
  userProfile.value.email2 = userStore.userData.email2
  isDirty.value = false
  showDialog.value = true
}
const save = async () => {
  const result = await accountFormRef.value.validate()
  if (!result.valid) return

  progressbarStore.showLoading()
  //isLoading.value = true
  try {
    const param = {
      customerCode: userStore.userData.customerCode,
      orgEmail: userStore.userData.email,
      ...userProfile.value
    }
    //console.log('>> Update account param', param, userStore.isCustomerMode)
    const response = await $axios.put(
      userStore.isCustomerMode ? useApi().authApiForCustomer.USER : useApi().authApi.USER,
      param
    )
    if (response.header.isSuccessful) {
      const userDataCookie = useCookie(appConfig.public.CLIENT_USER_COOKIE)
      userDataCookie.value.email = userProfile.value.email
      userDataCookie.value.email2 = userProfile.value.email2
      setUserData(userDataCookie.value)
      //userData.email = userProfile.value.email
      //userData.email2 = userProfile.value.email2
      showSnackbar(response.data)
      close()
    }
  } catch (e) {
    showSnackbar(e)
  }
  //isLoading.value = false
  setTimeout(() => {
    progressbarStore.hideLoading()
  }, 100)
}
const close = () => {
  showDialog.value = false
  clearPassword()
}

// expose
defineExpose({
  init
})
</script>

<style scoped></style>
